import { render, staticRenderFns } from "./PpStaticPage.vue?vue&type=template&id=9634bc6e&scoped=true&"
import script from "./PpStaticPage.vue?vue&type=script&lang=js&"
export * from "./PpStaticPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9634bc6e",
  null
  
)

export default component.exports